import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const SuccessClaim = ({ IMAGE_BASE_URL, digitalorderDetailsData }) => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      {/* Circular Image with Check Badge */}
      <Box sx={{ position: "relative", display: "inline-block", mb: 3 }}>
        {/* Outer Circle */}
        <Box
          sx={{
            width: { xs: 140, sm: 160 },
            height: { xs: 140, sm: 160 },
            borderRadius: "50%",
            border: "6px solid #9ED9C3", // light green border
            backgroundColor: "#f5f5f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {/* Inner Image */}
          <img
            src={`${IMAGE_BASE_URL}/${digitalorderDetailsData?.variantImageUrl}`}
            alt="Subscription"
            style={{
              //width: "70%",
              //height: "70%",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/120";
            }}
          />
        </Box>

        {/* Green Check Badge */}
        <Box
          sx={{
            position: "absolute",
            bottom: 6,
            right: 6,
            width: 44,
            height: 44,
            borderRadius: "50%",
            backgroundColor: "#22A06B",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "4px solid #ffffff",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          }}
        >
          <CheckIcon sx={{ color: "#fff", fontSize: 26 }} />
        </Box>
      </Box>

      {/* Success Text */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "#1a1a1a",
          mb: 1,
        }}
      >
        Successfully Claimed!
      
      </Typography>

      {/* Subtitle */}
      
      {digitalorderDetailsData.fulfilmentType == "SUBSCRIPTION" &&<>
        <Typography
          variant="body1"
          sx={{
            color: "#6b7280",
            fontSize: { xs: "16px", sm: "18px" },
          }}
      >
        Enjoy Your Subscription
      </Typography>
      </>}
      
    </Box>
  );
};

export default SuccessClaim;